import { useState, useEffect } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'

const ContactForm = ({ clienteId, contact, onSubmit, onCancel, isLoading }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    tipo_contacto: 'principal',
    email: '',
    telefono: '',
    telefono_movil: '',
    extension: '',
    puesto: '',
    principal: false,
    notas: ''
  })

  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (contact) {
      setFormData({
        nombre: contact.nombre ?? contact.name ?? '',
        tipo_contacto: contact.tipo_contacto || 'principal',
        email: contact.email || '',
        telefono: contact.telefono ?? contact.phone ?? '',
        telefono_movil: contact.telefono_movil ?? contact.phone_mobile ?? '',
        extension: contact.extension ?? '',
        puesto: contact.puesto ?? contact.position ?? '',
        principal: contact.principal ?? contact.is_primary ?? false,
        notas: contact.notas ?? contact.notes ?? ''
      })
    } else {
      setFormData({
        nombre: '',
        tipo_contacto: 'principal',
        email: '',
        telefono: '',
        telefono_movil: '',
        extension: '',
        puesto: '',
        principal: false,
        notas: ''
      })
    }
  }, [contact])

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }))
    
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev }
        delete newErrors[name]
        return newErrors
      })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    
    const newErrors = {}
    if (!formData.nombre?.trim()) newErrors.nombre = 'Nombre es requerido'
    if (!formData.email?.trim()) newErrors.email = 'Email es requerido'
    const phone = (formData.telefono || formData.telefono_movil || '').trim()
    if (!phone) newErrors.telefono = 'Teléfono o Teléfono móvil es requerido'
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
    
    // Mapear al formato que espera la API
    const submitData = {
      client: clienteId,
      name: formData.nombre.trim(),
      email: formData.email.trim(),
      phone: phone,
      phone_mobile: (formData.telefono_movil || '').trim(),
      extension: (formData.extension || '').trim(),
      notes: (formData.notas || '').trim(),
      position: (formData.puesto || '').trim(),
      is_primary: !!formData.principal,
      tipo_contacto: formData.tipo_contacto || 'principal'
    }
    if (contact?.id) submitData.id = contact.id
    
    onSubmit(submitData)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Nombre *</Form.Label>
            <Form.Control
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              isInvalid={!!errors.nombre}
              required
            />
            {errors.nombre && <Form.Control.Feedback type="invalid">{errors.nombre}</Form.Control.Feedback>}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Tipo de Contacto *</Form.Label>
            <Form.Select
              name="tipo_contacto"
              value={formData.tipo_contacto}
              onChange={handleChange}
              required
            >
              <option value="principal">Contacto Principal</option>
              <option value="contabilidad">Contabilidad</option>
              <option value="facturacion">Facturación</option>
              <option value="cobranza">Cobranza</option>
              <option value="administrativo">Administrativo</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Email *</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
              required
            />
            {errors.email && <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>}
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Puesto</Form.Label>
            <Form.Control
              type="text"
              name="puesto"
              value={formData.puesto}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Teléfono *</Form.Label>
            <Form.Control
              type="tel"
              name="telefono"
              value={formData.telefono}
              onChange={handleChange}
              isInvalid={!!errors.telefono}
              placeholder="Fijo o móvil"
            />
            {errors.telefono && <Form.Control.Feedback type="invalid">{errors.telefono}</Form.Control.Feedback>}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Teléfono Móvil</Form.Label>
            <Form.Control
              type="tel"
              name="telefono_movil"
              value={formData.telefono_movil}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Extensión</Form.Label>
            <Form.Control
              type="text"
              name="extension"
              value={formData.extension}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Notas</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="notas"
              value={formData.notas}
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Check
            type="checkbox"
            name="principal"
            label="Contacto Principal"
            checked={formData.principal}
            onChange={handleChange}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
        <Button variant="primary" type="submit" disabled={isLoading}>
          {isLoading ? 'Guardando...' : (contact ? 'Actualizar' : 'Crear')}
        </Button>
      </div>
    </Form>
  )
}

export default ContactForm

